export default "__VITE_ASSET__CbBV0hwq__"